import { RefObject, useEffect } from 'react'

const checkerPointIsInside =
  (top: number, bottom: number, left: number, right: number) =>
  (x: number, y: number) =>
    x >= left && x <= right && y >= top && y <= bottom

const getCoordinates = (event: MouseEvent | TouchEvent) =>
  event instanceof MouseEvent
    ? { x: event.pageX, y: event.pageY }
    : { x: event.touches[0].pageX, y: event.touches[0].pageY }

type CheckerPointIsInsideReturnType = ReturnType<typeof checkerPointIsInside>

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: MouseEvent | TouchEvent) => void,
  isBookCallBtn = false
) {
  useEffect(() => {
    let isInside: CheckerPointIsInsideReturnType

    if (ref.current) {
      const rectSize = ref.current.getBoundingClientRect()
      isInside = checkerPointIsInside(
        rectSize.top,
        rectSize.bottom,
        rectSize.left,
        rectSize.right
      )
    }
    const listener = (event: MouseEvent | TouchEvent) => {
      const coords = getCoordinates(event)
      const target = event.target as Element

      if (
        !ref.current ||
        ref.current.contains(target) ||
        isInside(coords.x, coords.y) ||
        (isBookCallBtn && target.id === 'book-call-btn')
      ) {
        return
      }
      handler(event)
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
}
